"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Modal_1 = __importDefault(require("react-bootstrap/Modal"));
var react_i18next_1 = require("react-i18next");
var util_1 = require("@aperza/util");
var CatalogPartner_module_scss_1 = __importDefault(require("./CatalogPartner.module.scss"));
var CatalogPartnerModal = function (props) {
    var env = util_1.AppConfigService.getEnvironment();
    var documentId = props.documentId, _a = props.show, show = _a === void 0 ? false : _a, onCloseHandler = props.onCloseHandler;
    var _b = react_1.useState(610), height = _b[0], setHeight = _b[1];
    var t = react_i18next_1.useTranslation(['catalog']).t;
    var onIframeLoad = function () {
        //find the height of the internal page
        // var the_height = document.getElementById('iframe').contentWindow.document.body.scrollHeight;
        //change the height of the iframe
        // document.getElementById('iframe').height = the_height;
    };
    react_1.useEffect(function () {
        window.addEventListener('message', onMessage, false);
    }, []);
    react_1.useEffect(function () { }, [height]);
    var onMessage = function (event) {
        if (event) {
            if (event.origin.includes('//cloud.')) {
                try {
                    var eventData = event.data;
                    if (eventData.event === 'loadedContentHeight') {
                        setHeight(eventData.height);
                    }
                }
                catch (e) {
                    console.log('error parsing onMessage: ', e);
                }
            }
        }
    };
    return (react_1.default.createElement(Modal_1.default, { show: show, onHide: onCloseHandler, className: "modal-catalog-preview fade", dialogClassName: CatalogPartner_module_scss_1.default.CatalogPreviewModal, size: 'lg', centered: true },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, t('catalog.partner.modalTitle'))),
        react_1.default.createElement(Modal_1.default.Body, { className: "p-0" },
            react_1.default.createElement("iframe", { id: "partner-iframe", src: util_1.AppConfigService.getCloudPartnerHost(env) + '/apply/new/' + documentId, frameBorder: "0", width: "100%", height: height })),
        react_1.default.createElement(Modal_1.default.Footer, null,
            react_1.default.createElement("button", { type: "button", onClick: onCloseHandler, className: "btn btn-default btn-wide btn-xl", "data-dismiss": "modal", "aria-label": "Close" }, t('close')))));
};
CatalogPartnerModal.displayName = 'CatalogPartnerModal';
exports.default = CatalogPartnerModal;
